import axios, { isAxiosError } from "axios"
import { useState, useEffect } from "react"
import ModalImage, { Lightbox } from "react-modal-image";
import { Tooltip } from "react-tooltip";
import { RetailerColumnNames } from "../../constants";
import ImageTagsDetails from "../SocialTrendsTags/ImageTagsDetails";
import Collection from "./Collection";
import roundtocloses0_5_value from "./Utils/roundToClosest_0_5";
import showFloatToPercentage from "./Utils/showFloatToPercentage";

const TrendImagesType = ({ trendType, category, imagesSort, searchParams, tag, value, page, setCount, setBrandCounts, setLoading, selectedBrand, isCoord = false, selectedRetailer, setRetailerCounts }) => {
  const [images, setImages] = useState([])
  const [allCollectionNames, setAllCollectionNames] = useState([])
  const [collectionSets, setCollectionSets] = useState({})
  const limit = 100
  const [localImageCount, setLocalImageCount] = useState(1)
  const [modalImage, setModalImage] = useState(null)

  const getCollectionNames = async () => {
    const resp = await axios.get(`/api/saved-images/collections`)
    setAllCollectionNames(resp.data.collections)
    let collectionSetsTemp = {}
    resp.data.collections.forEach(coll => {
      collectionSetsTemp[coll._id] = new Set(coll[trendType === 'social' ? 'savedImages' : 'savedProducts']);
    })
    setCollectionSets(collectionSetsTemp)
  }


  const addImageToCollection = async (image, collectionId) => {
    const body = {
      imageId: image._id,
      collectionId
    }
    if (collectionSets[collectionId] && collectionSets[collectionId].has(image._id)) {
      body.delete = true
    }
    await axios.post(`/api/saved-images/image/${trendType}`, body)
    getCollectionNames()
  }


  const getImages = async (signal) => {
    setLoading(true)
    setImages([])
    const gender = searchParams.get('gender') == 'F' ? 'Female' :
      searchParams.get('gender') == 'M' ? 'Male' :
        searchParams.get('gender') ? searchParams.get('gender') :
          'Female'
    const categoryOfImages = category ? category : searchParams.get('category')
    try {
      const resp = await axios.get(`/social-trends-v2-api/leaderboard-trend-images/${trendType}?gender=${gender}&category=${categoryOfImages.split('&').join('%26')}&geography=${searchParams.get('geography') || 'All'}&source=${searchParams.get('source') || ''}&time=${''/*searchParams.get('time') || '30 days'*/}&page=${page || 1}&limit=100${searchParams.get('tag') ? `&tag=${encodeURIComponent(searchParams.get('tag'))}` : ''}${searchParams.get('value') ? `&value=${encodeURIComponent(searchParams.get('value'))}` : ''}&trendTag=${encodeURIComponent(tag)}&trendValue=${encodeURIComponent(value)}${trendType === 'retailer' && selectedRetailer != null ? `&retailer=${encodeURIComponent(selectedRetailer)}` : ''}${trendType === 'retailer' && selectedBrand != null ? `&brand=${encodeURIComponent(selectedBrand)}` : ''}&sort=${imagesSort || 'recency'}${isCoord ? `&coord=true` : ''}`, { signal })
      setLoading(false)
      setCount(prev => Math.max(prev, resp.data.count))
      setLocalImageCount(resp.data.count)
      setImages(resp.data.images)
      if (trendType === 'retailer') {
        setBrandCounts(resp.data.brandCounts)
        setRetailerCounts(resp.data.retailerCounts)
      }
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
        throw e
      }
    }
  }

  const closeReactModal = () => {
    setModalImage(null)
  }

  const selectImageForModal = (e) => {
    const targetId = e.target && e.target.id ? e.target.id : null
    if (!targetId) {
      return
    }
    const imageUrl = targetId.split('modal-')[1] || null;
    if (imageUrl) {
      setModalImage(imageUrl)
    }

  }

  useEffect(() => {
    const abortController = new AbortController()
    getImages(abortController.signal)
    return () => {
      abortController.abort()
    }
  }, [searchParams, tag, value, page, selectedBrand, imagesSort, selectedRetailer])

  useEffect(() => {
    getCollectionNames()
  }, [])

  return <div className="w-[49%] shrink-0">
    <div className='m-2 justify-center flex'><img src={trendType == 'social' ? '/social-logo.png' : '/retailer-logo.png'} className='h-5' /></div>
    <div className="w-full flex flex-wrap my-2">
      {images.map(image => <div className="w-full lg:w-1/3 p-2 border border-slate-300">
        <div className="flex justify-center items-center relative group">
          <div className="relative group " data-tooltip-id={'trends-tooltip-' + (trendType == 'social' ? image.mediaId : image.pk)}>
            <Collection image={image} collections={allCollectionNames} fetchCollections={getCollectionNames} addImageToCollection={addImageToCollection} collectionSets={collectionSets} />
            <div
              className="h-48 w-auto min-w-[20%]"
              onClick={selectImageForModal}
            >
              <img
                src={image[trendType == 'social' ? 'imageUrl' : 'image_url']}
                loading="lazy"
                className="h-48 w-auto"
                id={`modal-${image[trendType == 'social' ? 'imageUrl' : 'image_url']}`}
              />

            </div>
            <Tooltip id={'temporary-hidden-trends-tooltip-' + (trendType == 'social' ? image.mediaId : image.pk)} style={{ zIndex: 1100 }}>
              <div className="text-[10px] font-light">
                <h3 className="text-center">Trends of image</h3>
                {image.trends.map((catTrends, i) => <div className="my-2">
                  <div className="flex justify-between py-1 text-xs">
                    <h4>{i + 1}. {catTrends.category}</h4>
                    <div className="flex">
                      {trendType == 'social' ? <div className="px-2 ">{catTrends.aggregateRateOfGrowth} Sum ROG(social)</div> : <>
                        <div className="px-2 text-yellow-600 w-20 text-wrap shrink-0">{catTrends.socialAggregateRateOfGrowth} Sum ROG(social)</div>
                        {false ? <div className="px-2 w-20 shrink-0 text-wrap">{catTrends.aggregateRateOfGrowth} Sum ROG(retailer)</div> : null}
                      </>}
                      <h3>{catTrends.success} Success points </h3>
                    </div>
                  </div>
                  <div className="ml-4">

                    {
                      catTrends.trends.sort((a, b) => b.success - a.success).map(sil => <div key={sil.silhouette}>
                        <div className="flex justify-between w-full pr-2 mb-1 mt-3 text-xs">
                          <div>{sil.silhouette}</div>
                          <div className="flex">
                            {trendType == 'social' ? <div className="px-2 ">{sil.aggregateRateOfGrowth} Sum ROG(social)</div> : <>
                              <div className="px-2 text-yellow-600 w-20 text-wrap shrink-0">{sil.socialAggregateRateOfGrowth} Sum ROG(social)</div>
                              {false ? <div className="px-2 w-20 shrink-0 text-wrap">{sil.aggregateRateOfGrowth} Sum ROG(retailer)</div> : null}
                            </>}
                            <div>{sil.success} Success points</div>
                          </div>
                        </div>

                        {sil.trends.map(trend => <div className="flex justify-between px-2">
                          <p className="text-wrap pr-2">{trend.primaryTagValue} <span className="font-semibold">x</span> {trend.secondaryValue}</p>
                          <div className="flex">
                            {trendType == 'social' ? <p className="px-2">{Math.ceil(trend.rateOfGrowth * 1000) / 10}%</p> : <>
                              <p className="px-2 text-yellow-600">{Math.ceil(trend.socialrateOfGrowth * 1000) / 10}%</p>
                              {false ? <p className="px-2">{Math.ceil(trend.rateOfGrowth * 1000) / 10}%</p> : null}
                            </>
                            }
                            <p>{trend.lifecycle}</p>
                          </div>
                        </div>)}
                      </div>)
                    }
                  </div>
                </div>)}

              </div>
            </Tooltip>
          </div>
        </div>
        {trendType == 'social' ? <div className="px-3 text-xs">
          <a href={`${image.postUrl}`} className='text-blue-600 font-medium' target='_blank'>{image.username}</a>
          <p>{new Date(image.timeStamp).toDateString()}</p>
          <ImageTagsDetails mediaId={image.mediaId} />
        </div> : <div className="px-3 text-xs">

          {['sales', 'reviews', 'bestsellerRank', 'retailerHashtag'].map(item => <div key={item} hidden={!image[item]} className=' max-w-40 text-[12px] font-normal'><span className="font-semibold">{RetailerColumnNames[item]}: </span>{image[item]}</div>)}
          <a href={`${image.product_url}`} className='text-blue-600 font-medium' target='_blank'>{image.retailer}</a>
          {['price', 'title'].map(item => <div key={item} hidden={!image[item]} className={`${item == 'title' ? 'text-nowrap overflow-hidden' : ''} max-w-40 text-[12px]`}><span className="font-semibold">{RetailerColumnNames[item]}: </span>{item == 'title' ? image[item].slice(0, 20) : image[item]}</div>)}
          <ImageTagsDetails mediaId={image.pk} isretailer={true} />
        </div>}

        <div
          className='text-[12px] font-medium text-left px-2'
          data-tooltip-id={'forecast-tooltip-' + image.mediaId}
        >
          Forecast Score : {image.forecastScore && Object.keys(image.forecastScore) ? <span className="">{roundtocloses0_5_value(showFloatToPercentage(Object.keys(image.forecastScore).reduce((prev, current) => image.forecastScore[current] + prev, 0)))}</span> : 0}
          <div className="text-[12px] mb-2">
            {
              image.forecastScore ? Object.keys(image.forecastScore)
                .map((category, i) => <div key={category} className="flex justify-between border-b pl-2">
                  <div><p className="text-wrap pr-2 flex">{i + 1}. {category} Forecast score</p></div>
                  <div className="text-center">{roundtocloses0_5_value(showFloatToPercentage(image.forecastScore[category]))}</div>
                </div >) : null}
          </div>
        </div>
      </div>)}
    </div>
    {modalImage ? <Lightbox
      medium={modalImage}
      large={modalImage}
      alt=""
      onClose={closeReactModal}
    /> : null}


  </div>
}

export default TrendImagesType
